// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__hjk2a","name":"ConsentHeader_name__Aiiid","birthday":"ConsentHeader_birthday__1yFUv","skeleton":"ConsentHeader_skeleton__sLR4Q"};